var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNfdCombineAdaptive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1506_25621)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.70707 18.9655C7.37651 18.9655 7.91919 18.3706 7.91919 17.6367C7.91919 16.9029 7.37651 16.3079 6.70707 16.3079C6.03763 16.3079 5.49495 16.9029 5.49495 17.6367C5.49495 18.3706 6.03763 18.9655 6.70707 18.9655ZM6.70707 20.3829C7.79274 20.3829 8.71711 19.6258 9.06477 18.5669C9.16015 18.2764 9.21212 17.9632 9.21212 17.6367C9.21212 17.4705 9.19864 17.3076 9.17281 17.1495C8.96306 15.8652 7.9389 14.8905 6.70707 14.8905C5.47524 14.8905 4.45108 15.8652 4.24133 17.1495C4.2155 17.3076 4.20202 17.4705 4.20202 17.6367C4.20202 17.9632 4.25399 18.2764 4.34937 18.5669C4.69703 19.6258 5.62139 20.3829 6.70707 20.3829Z",
    fill: "url(#paint0_linear_1506_25621)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.94265 9.66366C4.94265 9.2478 5.25017 8.99926 5.62952 8.99926H8.43356C8.81291 8.99926 9.12043 9.2478 9.12043 9.66366C9.12043 10.0795 8.81291 10.3281 8.43356 10.3281H5.62952C5.25017 10.3281 4.94265 10.0795 4.94265 9.66366Z",
    fill: "url(#paint1_linear_1506_25621)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0073 10.173C11.2639 9.89172 11.2639 9.43561 11.0073 9.15429C10.7507 8.87297 10.3346 8.87297 10.078 9.15429C9.82139 9.43561 9.82139 9.89172 10.078 10.173C10.3346 10.4544 10.7507 10.4544 11.0073 10.173Z",
    fill: "url(#paint2_linear_1506_25621)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7245 17.5922C16.9811 17.3109 16.9811 16.8548 16.7245 16.5734C16.4679 16.2921 16.0518 16.2921 15.7952 16.5734C15.5386 16.8548 15.5386 17.3109 15.7952 17.5922C16.0518 17.8735 16.4679 17.8735 16.7245 17.5922Z",
    fill: "url(#paint3_linear_1506_25621)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.565656 7.8036C0.87806 7.8036 1.13131 7.52597 1.13131 7.18349C1.13131 6.84101 0.87806 6.56338 0.565656 6.56338C0.253253 6.56338 -5.3202e-09 6.84101 0 7.18349C5.3202e-09 7.52597 0.253253 7.8036 0.565656 7.8036Z",
    fill: "url(#paint4_linear_1506_25621)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.12121 6.65197C2.78234 6.65197 1.69697 7.84182 1.69697 9.30957V12.4544C1.69697 12.8591 1.92203 13.2062 2.24242 13.3535V17.5039C2.24242 18.091 2.67657 18.5669 3.21212 18.5669H4.34937C4.25399 18.2764 4.20202 17.9632 4.20202 17.6367C4.20202 17.4705 4.2155 17.3076 4.24133 17.1495H3.53535V13.5054C3.57122 13.514 3.60696 13.5234 3.64255 13.5334L4.27476 13.714L11.29 15.6466C11.8384 15.8103 12.4235 15.6088 12.7881 15.1308L14.1772 13.3094C14.2693 13.1886 14.4055 13.1188 14.5491 13.1188H16.1214C16.3892 13.1188 16.6062 12.8808 16.6062 12.5873V12.1886H17.3333H18.2151C18.3551 12.1886 18.4927 12.174 18.6263 12.146C19.4605 11.9709 20.1423 11.2722 20.3402 10.3382L21.2813 5.89898H21.3335C21.6905 5.89898 21.98 5.58169 21.98 5.19029C21.98 4.79889 21.6905 4.48159 21.3335 4.48159H13.6593C13.3498 4.48159 13.0589 4.64351 12.8763 4.91742L12.2389 6.13936C12.0495 6.4236 11.6376 6.50253 11.3217 6.23452C10.1236 4.99161 8.27601 3.57425 6.182 3.57422C3.90199 3.57419 2.29616 3.69797 1.00787 4.16874C0.669156 4.29251 0.486103 4.69386 0.599006 5.06518C0.71191 5.43649 1.07802 5.63717 1.41673 5.5134C2.55268 5.0983 4.01755 4.99158 6.18199 4.99161C7.64563 4.99163 8.70208 5.83146 9.80623 6.65197H4.12121ZM15.3131 6.65197V8.06936H4.12121C3.4964 8.06936 2.9899 8.62462 2.9899 9.30957V12.0128C3.31875 12.0212 3.64575 12.0708 3.96454 12.1607L4.61448 12.3464L11.6297 14.279C11.6906 14.2972 11.7556 14.2748 11.7962 14.2217L13.1853 12.4003C13.523 11.9574 14.0225 11.7014 14.5491 11.7014H15.3133V10.3726H12.5658C12.2088 10.3726 11.9194 10.0553 11.9194 9.66392C11.9194 9.27252 12.2088 8.95523 12.5658 8.95523H15.3133V5.89898H13.8234L13.3214 6.65197H15.3131ZM16.6062 10.7713H18.2151C18.6285 10.7713 18.9873 10.4588 19.0809 10.0174L19.9539 5.89898H16.6062V10.7713Z",
    fill: "url(#paint5_linear_1506_25621)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 17.1938C13.3333 17.179 13.3334 17.1642 13.3336 17.1495H9.17281C9.19864 17.3076 9.21212 17.4705 9.21212 17.6367C9.21212 17.9632 9.16015 18.2764 9.06477 18.5669H13.616C13.4348 18.151 13.3333 17.6854 13.3333 17.1938Z",
    fill: "url(#paint6_linear_1506_25621)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.94265 9.66366C4.94265 9.2478 5.25017 8.99926 5.62952 8.99926H8.43356C8.81291 8.99926 9.12043 9.2478 9.12043 9.66366C9.12043 10.0795 8.81291 10.3281 8.43356 10.3281H5.62952C5.25017 10.3281 4.94265 10.0795 4.94265 9.66366ZM11.0073 9.15429C11.2639 9.43561 11.2639 9.89172 11.0073 10.173C10.7507 10.4544 10.3346 10.4544 10.078 10.173C9.82139 9.89172 9.82139 9.43561 10.078 9.15429C10.3346 8.87297 10.7507 8.87297 11.0073 9.15429Z",
    fill: "url(#paint7_linear_1506_25621)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3875 12.7645H18.6263V12.146C18.4927 12.174 18.3551 12.1886 18.2151 12.1886H17.3333V14.2365C17.8576 14.4691 18.306 14.8645 18.6263 15.3654V14.1818H19.3875L20.5431 15.5992H18.7623C18.9845 16.0203 19.1214 16.5022 19.1471 17.0166H21.6988L22.3127 17.7696H19.1042C19.0161 18.2993 18.8086 18.7834 18.5135 19.187H23.0351C23.8731 19.187 24.3166 18.1005 23.7581 17.4155L20.3515 13.2373C20.1062 12.9364 19.7556 12.7645 19.3875 12.7645Z",
    fill: "url(#paint8_linear_1506_25621)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7245 17.5922C16.9811 17.3109 16.9811 16.8548 16.7245 16.5734C16.4679 16.2921 16.0518 16.2921 15.7952 16.5734C15.5386 16.8548 15.5386 17.3109 15.7952 17.5922C16.0518 17.8735 16.4679 17.8735 16.7245 17.5922Z",
    fill: "url(#paint9_linear_1506_25621)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3336 17.1495C13.3334 17.1642 13.3333 17.179 13.3333 17.1938C13.3333 17.6854 13.4348 18.151 13.616 18.5669C14.0841 19.6409 15.0842 20.3829 16.2424 20.3829C17.1611 20.3829 17.9803 19.9161 18.5135 19.187C18.8086 18.7834 19.0161 18.2993 19.1042 17.7696C19.1353 17.5828 19.1515 17.3904 19.1515 17.1938C19.1515 17.1343 19.15 17.0753 19.1471 17.0166C19.1214 16.5022 18.9845 16.0203 18.7623 15.5992C18.72 15.519 18.6746 15.441 18.6263 15.3654C18.306 14.8645 17.8576 14.4691 17.3333 14.2365C16.9964 14.087 16.6282 14.0047 16.2424 14.0047C14.6493 14.0047 13.3552 15.4086 13.3336 17.1495ZM16.2424 15.4221C15.3498 15.4221 14.6263 16.2153 14.6263 17.1938C14.6263 18.1723 15.3498 18.9655 16.2424 18.9655C16.6629 18.9655 17.0458 18.7895 17.3333 18.501C17.6561 18.1771 17.8586 17.7114 17.8586 17.1938C17.8586 16.6762 17.6561 16.2105 17.3333 15.8866C17.0458 15.5981 16.6629 15.4221 16.2424 15.4221Z",
    fill: "url(#paint10_linear_1506_25621)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1506_25621",
    x1: 12.0034,
    y1: 3.57422,
    x2: 12.0034,
    y2: 20.3829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1506_25621",
    x1: 12.0034,
    y1: 3.57422,
    x2: 12.0034,
    y2: 20.3829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1506_25621",
    x1: 12.0034,
    y1: 3.57422,
    x2: 12.0034,
    y2: 20.3829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1506_25621",
    x1: 12.0034,
    y1: 3.57422,
    x2: 12.0034,
    y2: 20.3829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1506_25621",
    x1: 12.0034,
    y1: 3.57422,
    x2: 12.0034,
    y2: 20.3829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1506_25621",
    x1: 12.0034,
    y1: 3.57422,
    x2: 12.0034,
    y2: 20.3829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1506_25621",
    x1: 12.0034,
    y1: 3.57422,
    x2: 12.0034,
    y2: 20.3829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1506_25621",
    x1: 12.0034,
    y1: 3.57422,
    x2: 12.0034,
    y2: 20.3829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1506_25621",
    x1: 12.0034,
    y1: 3.57422,
    x2: 12.0034,
    y2: 20.3829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1506_25621",
    x1: 12.0034,
    y1: 3.57422,
    x2: 12.0034,
    y2: 20.3829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1506_25621",
    x1: 12.0034,
    y1: 3.57422,
    x2: 12.0034,
    y2: 20.3829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1506_25621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfdCombineAdaptive);
export default __webpack_public_path__ + "static/media/NfdCombineAdaptive.c6cfd811267cab2f7d05e14af4327cfb.svg";
export { ForwardRef as ReactComponent };